<template>

    <main class="temoignages-body-template">
        <article>
            <section class="text-right">
                <figure>
                    <img class="picture" v-if="item.picture" :src="require('../../assets/' + item.picture)" alt="">
                    <figcaption>
                        <p style="color: #A2C038">PIERRE BROCHET</p>
                        <p class="green">GABRIEL USER IN CEYZERIEU (01)</p>
                    </figcaption>
                </figure>

				<p class="number" :class="item.color">
                    400,000
                </p>
                <p class="green uppercase semiBold" style="margin-bottom: 10px">
                  alliance alarms have been handled by the Groupama Box Habitat standalone connected remote home protection solution.
                </p>
                <img class="icono w300" :src="require('../../assets/securite.jpg')" style="margin-top: 10px; margin-bottom: 40px">


                <p class="label green">
                   MON DROIT
                </p>

                <p class="green uppercase semiBold">
                    <a href="https://www.mondroit-groupama-pj.fr/home" target="_blank">An online platform to help achieve an amicable resolution</a> of everyday disputes offered by Groupama Protection Juridique in partnership with a law firm.
                </p>


                <p class="label green">
                   VIVI GROUPAMA
                </p>

                <p class="green uppercase semiBold">
                 The first loyalty programme launched by Groupama Assicurazioni gives customers the opportunity to collect points entitling them to discounts on insurance premiums.
                </p>

            </section>

            <section>
                <svg class="quote" :class="item.color" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 59.8 42.61">
                    <path d="M59.8,0H45.59C39,11,34.91,18,33.43,20.83a17.92,17.92,0,0,0-2.17,8.26c0,7.57,6.36,13.52,14.34,13.52s14.2-6,14.2-13.52c0-5.28-2.7-9.2-8.11-11.5ZM28.55,0H14.21C7.57,11.09,3.65,18.13,2.16,21A17.49,17.49,0,0,0,0,29.09c0,7.57,6.22,13.52,14.2,13.52s14.2-6,14.2-13.52c0-5.28-2.7-9.2-8.11-11.5Z"/>
                </svg>
                <h2> It’s essential to also have an assistance and safety app like Gabriel!</h2>
                <h1>   


                    <span>Offering Pierre</span>
                    <span>and all our <em :class="item.color">customers</em></span>
                    <span><em :class="item.color">and members</em></span>
                    <span>a comprehensive range</span>
                    <span>of services</span>
                </h1>

               <!-- <h3>
                    à la tête d'une exploitation<br>
                    de 350 HA, en blé, colza et orge
                </h3>-->
                <p>
                    Pierre is head of a family with 4 children. He lives in Ceyzérieu at the foot of the Grand Colombier Mountain in winemaking country. For the past few years, he has been using the <span class="marker" :class="item.color">Gabriel</span> app from Groupama. When enjoying his favourite sport of cycling, he sees the un œil sur moi (keep an eye on me) function as essential when riding isolated roads. <br><br>
                  So activating Gabriel has become an everyday habit, and a family habit too, because his 17 year-old daughter - a firefighter and rugby team member - uses it when she goes running for training.  <br><br>
                    So if either of them changes route, other family members can see exactly where they are, so that if there’s a problem they can be located and assisted very easily thanks to the app. <br><br>
                   Pierre says that he’s now in the age bracket where it’s important to keep in shape, but where it's equally important to look beyond purely route finding and performance apps: “It’s essential to have an assistance and safety app too”. The services offered by the Gabriel app are also relevant to everyday family life. For example, when her car broke down, its geolocation function meant that Pierre’s wife was able to get roadside assistance very quickly. When they’re travelling as a family, it also helps them prepare for their getaway and call assistance services in other countries. <br><br>
              Lastly, with four teenagers between 13 to 17, Pierre also likes the reassurance of being able to see where everyone is geographically at any time. Their generation is ultra-connected and constantly geo-located via social media, so perhaps they’ll be future Gabriel users? 
                </p>
                <a href="" class="link">
                    <svg class="link-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 250 324">
                        <path d="M239,260v56a7.89,7.89,0,0,1-8,8H40A40.12,40.12,0,0,1,0,284V40A40.12,40.12,0,0,1,40,0H242c4,0,8,4,8,8V252a7.89,7.89,0,0,1-8,8Zm-16,16V260H40a23.69,23.69,0,0,0-24,24c0,14,10,24,24,24H223V292H37V276Zm11-31V16H40C26,16,16,26,16,40V253c7-5,14-8,24-8Z"/>
                        <path d="M197,64v61H52V64ZM183,78H67v33H183Z"/>
                    </svg>
                   <div class="link-content">
                        <p>To learn more about the facts that marked our year</p>
                        <p><span>DOWNLOAD</span> THE ANNUAL REPORT</p>
                    </div>
                </a>
            </section>
        </article>
    </main>


</template>

<script>

    export default {
        name: "TemoignageBody",
        props: ['item'],
        mounted() {

            window.removeEventListener('scroll', this.scroll)
            window.addEventListener('scroll', this.scroll)

        },
        methods: {
            scroll() {
                if(!document.querySelector('.temoignages-item-bar.active'))
                    return;

                if (this.isInViewport(document.querySelector('.temoignages-item-bar.active')))
                    document.querySelector('.temoignages-item-bar.active + .temoignages-item-content .close').style.opacity = 0;
                else
                    document.querySelector('.temoignages-item-bar.active + .temoignages-item-content .close').style.opacity = 1;
            },
            isInViewport(elem) {
                let bounding = elem.getBoundingClientRect();
                return (
                    bounding.top >= -document.querySelector('.temoignages-item-bar.active').clientHeight &&
                    bounding.left >= 0 &&
                    bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
                    bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
                );
            }
        }
    }
</script>
